import { useState } from "react";
import { Link } from "react-router-dom";
import { useFetch } from "@/lib/useFetch";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { PageHeader } from "@/mockups/ui";
import { Search, FileText } from "lucide-react";

const STATUS_STYLE = {
  Abierto: "bg-chart-4/12 text-chart-4",
  Ganado: "bg-primary/12 text-primary",
  Perdido: "bg-destructive/12 text-destructive",
};

function money(amount, currency) {
  if (amount == null) return "—";
  try {
    return new Intl.NumberFormat("es-ES", { style: "currency", currency: currency || "EUR" }).format(amount);
  } catch { return `${amount} ${currency || ""}`; }
}

export default function Presupuestos() {
  const { data: deals, loading } = useFetch("/deals");
  const [search, setSearch] = useState("");

  const rows = (deals || []).filter((d) =>
    !search ||
    d.title?.toLowerCase().includes(search.toLowerCase()) ||
    d.company_name?.toLowerCase().includes(search.toLowerCase()) ||
    d.reference?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="space-y-6 animate-fade-in-up">
      <PageHeader title="Propuestas" subtitle="Oportunidades y propuestas comerciales importadas desde Teamleader" />

      <div className="relative w-full sm:max-w-xs">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input placeholder="Buscar presupuesto…" value={search} onChange={(e) => setSearch(e.target.value)} className="pl-9 h-9" data-testid="deal-search" />
      </div>

      {loading ? (
        <div className="py-16 flex justify-center"><div className="h-7 w-7 rounded-full border-2 border-primary border-t-transparent animate-spin" /></div>
      ) : rows.length === 0 ? (
        <Card className="border-border shadow-none py-16 text-center text-sm text-muted-foreground">
          <FileText className="h-8 w-8 mx-auto mb-3 opacity-40" />
          No hay propuestas. Conecta y sincroniza Teamleader en <Link to="/ajustes" className="text-primary underline">Integraciones</Link>.
        </Card>
      ) : (
        <Card className="border-border shadow-none overflow-hidden">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Título</TableHead>
                <TableHead>Referencia</TableHead>
                <TableHead>Cliente</TableHead>
                <TableHead className="text-right">Importe</TableHead>
                <TableHead>Estado</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {rows.map((d) => (
                <TableRow key={d.id} data-testid={`deal-row-${d.id}`}>
                  <TableCell className="font-medium">{d.title}</TableCell>
                  <TableCell className="text-muted-foreground">{d.reference || "—"}</TableCell>
                  <TableCell className="text-muted-foreground">{d.company_name || d.contact_name || "—"}</TableCell>
                  <TableCell className="text-right font-medium">{money(d.amount, d.currency)}</TableCell>
                  <TableCell>
                    <Badge variant="outline" className={`border-transparent font-medium ${STATUS_STYLE[d.status_label] || "bg-muted text-muted-foreground"}`}>
                      {d.status_label}
                    </Badge>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Card>
      )}
    </div>
  );
}
